var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_1921)",
    stroke: "#606f8d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.0673 17.296c2.8245 2.8245 7.4039 2.8244 10.228-7.2e-5s2.8245-7.4038 0-10.228c-2.8245-2.8245-7.4039-2.8245-10.228 0-2.8245 2.8245-2.8245 7.4039-3.6e-5 10.228z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.296 17.296 8.1904 8.1905"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_1921"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.946,
    height: 29.946,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.62a851c89b2963325b6fc491c2a23062.svg";
export { ForwardRef as ReactComponent };